// src/components/StarRating.jsx
import React from "react";
import { Star } from "lucide-react";

/**
 * Renders 5 stars, filled proportionally to `rating` (supports halves, e.g. 4.5).
 */
const StarRating = ({ rating = 5, size = 20, showValue = true }) => {
  return (
    <div className="flex items-center mb-4">
      {[1, 2, 3, 4, 5].map((star) => {
        const fill = Math.max(0, Math.min(1, rating - (star - 1))) * 100;
        return (
          <span
            key={star}
            className="relative inline-block mr-0.5"
            style={{ width: size, height: size }}
            aria-hidden="true"
          >
            <Star size={size} className="absolute inset-0 text-gray-300" />
            <span
              className="absolute inset-0 overflow-hidden"
              style={{ width: `${fill}%` }}
            >
              <Star size={size} className="text-yellow-500 fill-current" />
            </span>
          </span>
        );
      })}

      {showValue && (
        <span className="ml-2 text-sm font-semibold text-gray-600">
          {Number(rating).toFixed(1)}
        </span>
      )}
      <span className="sr-only">{`Rated ${rating} out of 5`}</span>
    </div>
  );
};

export default StarRating;